module.exports = {
  props: ['value'],

  methods: {
    toggle () {
      this.$emit('input', !this.value)
    }
  },
  template: `
    <div @click="toggle" class="d-flex h-pointer">
      <div class="checkbox">
        <i v-if="value" class="icon-checkmark h-text-green"></i>
      </div>
      <span class="ml-2"><slot></slot></span>
    </div>
  `
}